import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { IElementsViewModel } from 'src/app/ViewModel/ElementsModel';
import { ElementsService } from 'src/app/Service/elements/elements.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { CommonService } from 'src/app/Service/Common.service';
import * as moment from 'moment';

const createFormGroup = (dataItem: { dE_Description: any; is_Active: any; dE_Id: any; }) => new FormGroup({
  'dE_Description': new FormControl(dataItem.dE_Description, Validators.required),
  'is_Active': new FormControl(dataItem.is_Active),
  'dE_Id': new FormControl(dataItem.dE_Id),
});

const matches = (el: { matches: any; msMatchesSelector: any; }, selector: string) => (el.matches || el.msMatchesSelector).call(el, selector);

@Component({
  selector: 'app-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.css']
})
export class ElementsComponent implements OnInit {

  @ViewChild(GridComponent)
  private grid!: GridComponent;
  enableFilter = false;
  enableFullscreen = false;
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];
  public formGroup!: any|FormGroup;
  private editedRowIndex!: any | number;
  private docClickSubscription: any;
  private isNew!: boolean;
  memberId!: number;
  /**Elements array */
  public elementList: IElementsViewModel[] = [];

  constructor(private _elementService: ElementsService, private _notificationService: NotificationService,private _commonService: CommonService, private renderer: Renderer2) { }

  ngOnInit() {
    this.memberId = this._commonService.getLoggedInUserId();
    this.getElementsList();
    this.docClickSubscription = this.renderer.listen('document', 'click', this.onDocumentClick.bind(this));
  }

  /**
   * Get Elements list
   */
  getElementsList() {
    this._elementService.GetElementsList().subscribe((data: IElementsViewModel[]) => {
      this.elementList = data.map(x => {
        let result: IElementsViewModel = {
          dE_Id: x.dE_Id, dE_Description: x.dE_Description, is_Active: x.is_Active, user_Id: this.memberId ,
          created_By : x.created_By,
          created_On : x.created_On,
          modified_By : x.modified_By,
          modified_On : x.modified_On
        };
        return result;
      });
    });
  }

  /**
   * Add New Element Row
   */
  public addHandler(): void {
    this.closeEditor();

    this.formGroup = createFormGroup({
      dE_Description: '',
      is_Active: true,
      dE_Id: '',
    });
    this.isNew = true;

    this.grid.addRow(this.formGroup);
  }

  /**
   * Element Cell Click Handler
   */
  public cellClickHandler(data:any): void {
    if (data.isEdited || (this.formGroup && !this.formGroup.valid)) {
      return;
    }
    this.saveCurrent();
    this.formGroup = createFormGroup(data.dataItem);
    this.editedRowIndex = data.rowIndex;
    this.grid.editRow(data.rowIndex, this.formGroup);
  }

  /**
  * Close Cell Editor
  */

  private closeEditor(): void {
    this.grid.closeRow(this.editedRowIndex);

    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  /**
  * Element Cell Validation Check
  */
  private onDocumentClick(e: any): void {
    if (this.formGroup && this.formGroup.valid &&
      !matches(e.target, '#elementsGrid tbody *, #elementsGrid .k-grid-toolbar .k-button')) {

      this.saveCurrent();
    }
  }

  /**
  * 
  * Add/Update Elements API Call
  */
  private saveCurrent(): void {
    if (this.formGroup) {
      let element: IElementsViewModel = {
        dE_Description: this.formGroup.get('dE_Description').value,
        is_Active: this.formGroup.get('is_Active').value,
        dE_Id: this.formGroup.get('dE_Id').value, 
        user_Id: this.memberId
      };
      let existingElements: IElementsViewModel[] = this.elementList.filter(x => x.dE_Description == element.dE_Description
        && x.is_Active == element.is_Active);
      if (existingElements.length > 0) {
        //this._notificationService.showToast("Element already exists.", "Warning");
      }
      else {
        this._elementService.insertUpdateElements(element).subscribe((res: StandardOutputModel) => {
          this.saveElement(res, element);
        });
      }

      this.closeEditor();
      this.getElementsList();
    }
  }
  /**
   * Close the row editor
   */
  public cancelHandler(): void {
    this.closeEditor();
  }

  /**
   * Add/Update element
   * @param res Result Output
   * @param element Element Output
   */
  public saveElement(res: StandardOutputModel, element: IElementsViewModel) {
    if (res.successCode == 200) {
      if (element.dE_Id) {
        let filteredElement: IElementsViewModel = this.elementList.filter(x => x.dE_Id == element.dE_Id)[0];
        filteredElement.dE_Description = element.dE_Description;
        filteredElement.is_Active = element.is_Active;
      }
      else {
        let resElement: IElementsViewModel = { dE_Id: +res.result, dE_Description: element.dE_Description, is_Active: element.is_Active, user_Id: this.memberId }
        this.elementList.splice(0, 0, resElement);
        this.elementList = [...this.elementList];
      }
      this._notificationService.showToast(res.successMessage, "Success");
      this.getElementsList();
    }
    else if (res.successCode == 500) {
      this._notificationService.showToast(res.successMessage, "Warning");

    }
  }
  /**
   * Toggle filter
   */
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }
  /**
   * Toggle full screen
   */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  /**
   * Element active status on change event(Kendo switch)
   * @param value True/false
   */
  public onChange(value: boolean): void {
    this.formGroup.get('is_Active').setValue(value);
  }

}
